/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The Route Id that the UI has access to
 */
export const RouteId = {
  Alarms: "alarms",
  Blast: "blast",
  CoincidentPeaks: "coincident-peaks",
  CompressorSequencer: "compressor-sequencer",
  CondenserSequencer: "condenser-sequencer",
  EnergyAi: "energy-ai",
  Equipment: "equipment",
  FacilityConfig: "facility-config",
  HelpCenter: "help-center",
  IoStatus: "io-status",
  Map: "map",
  Netkit: "netkit",
  OfflineEscapeHatch: "offline-escape-hatch",
  OfflineFaq: "offline-faq",
  ProcessView: "process-view",
  Reports: "reports",
  Trends: "trends",
  SensorCalibration: "sensor-calibration",
  Shutdown: "shutdown",
  SiteNavigation: "site-navigation",
  Support: "support",
  System: "system",
  UserManagement: "user-management",
} as const;
/**
 * The Route Id that the UI has access to
 */
export type RouteId = OpenEnum<typeof RouteId>;

export type AccessControl = {
  /**
   * The Route Id that the UI has access to
   */
  routeId?: RouteId | undefined;
  /**
   * Whether the route has write access
   */
  write?: boolean | undefined;
};

/** @internal */
export const RouteId$inboundSchema: z.ZodType<RouteId, z.ZodTypeDef, unknown> =
  openEnums.inboundSchema(RouteId);

/** @internal */
export const AccessControl$inboundSchema: z.ZodType<
  AccessControl,
  z.ZodTypeDef,
  unknown
> = z.object({
  route_id: types.optional(RouteId$inboundSchema),
  write: types.optional(types.boolean()),
}).transform((v) => {
  return remap$(v, {
    "route_id": "routeId",
  });
});

export function accessControlFromJSON(
  jsonString: string,
): SafeParseResult<AccessControl, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AccessControl$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AccessControl' from JSON`,
  );
}
